module.exports = __webpack_public_path__ + "img/Empresa.862b0d1.svg";